import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { Breadcrumb } from "antd";
import { previousStep } from "../redux/actions/miscActions";
import EmployeeList from "./EmployeeList";
import LoonBelRapport from "./LoonBelRapport";
import EmTable from "./utils/EmTable";

export class EmployeeTable extends Component {
  componentDidMount = () => {
    const { response } = this.props.formData;
    if (response === null) {
      this.props.history.push("/");
    }
    this.props.previousStep();
    this.props.previousStep();
  };

  render() {
    const { response } = this.props.formData;
    const { loonstroken, loonbelastingRapport, company } = response;
    const loonStrokenList = loonstroken.sort(
      (a, b) => a.employee.personeelsNummer - b.employee.personeelsNummer
    );

    const tableOptions = {
      dataSource: loonStrokenList,
      // dataSource: response,
    };

    return (
      <div className="employee-table">
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="tax-form">Home</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Records</Breadcrumb.Item>
        </Breadcrumb>
        <div className="content">
          <LoonBelRapport data={loonbelastingRapport} company={company} />
          {/* <EmTable {...tableOptions} /> */}
          <EmployeeList employees={loonStrokenList} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  formData: state.formData,
});

export default connect(mapStateToProps, { previousStep })(
  withRouter(EmployeeTable)
);
